import Slider from "../../../../../node_modules/@tannerhodges/snap-slider/snap-slider.js";
